import { render, staticRenderFns } from "./stepsBank.vue?vue&type=template&id=a4d7aaba&scoped=true&"
import script from "./stepsBank.vue?vue&type=script&lang=ts&"
export * from "./stepsBank.vue?vue&type=script&lang=ts&"
import style0 from "./stepsBank.vue?vue&type=style&index=0&id=a4d7aaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d7aaba",
  null
  
)

export default component.exports